module.exports = __webpack_public_path__ + "img/rudy.ffbc3d40.png";